export default {
	data: {
		description: '',
		modalParams: {},
		isLoading: false,
		activeModal: null,
	},
	methods: {
		deactivateModal () {
			this.activeModal = null;
		},
		deleteGroup (id) {
			this.modalParams = {
				deletable: 'group',
				redirectPath: '/groups',
				deletePath: '/groups/' + id
			};
			this.activeModal = 'delete-modal';
		},
		deleteDiscussion (id, redirectPath) {
			this.modalParams = {
				deletable: 'discussion',
				redirectPath: redirectPath,
				deletePath: '/discussions/' + id
			};
			this.activeModal = 'delete-modal';
		},
		submit() {
      if (this.$refs.form.checkValidity()) {
				this.isLoading = true;
        this.$refs.form.submit();
      }
    }
	}
}